import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { CodeInputModule } from 'angular-code-input';
import { first } from 'rxjs/operators';
import { IgnorePasswordManagersDirective } from 'src/app/shared/directives';
import { GoogleAnalyticsService } from 'src/app/shared/service/google-analytics.service';

@Component({
    selector: 'app-account-verification',
    templateUrl: './account-verification.component.html',
    styleUrls: ['./account-verification.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        TranslocoModule,
        CodeInputModule,
        MatIconModule,
        FlexLayoutModule,
        MatButtonModule,
        MatInputModule,
        IgnorePasswordManagersDirective
    ]
})
export class AccountVerificationComponent implements OnInit {
    private _code: number | undefined;

    @Input() header!: string;
    @Input() continueText: string | undefined;
    @Output() back = new EventEmitter<void>();
    @Output() codeProvided = new EventEmitter<number>();

    constructor(
        private readonly _transloco: TranslocoService,
        private _googleAnalyticsService: GoogleAnalyticsService
    ) {}

    ngOnInit() {
        this._transloco
            .selectTranslate('shared.continue')
            .pipe(first())
            .subscribe((message) => {
                if (
                    this.continueText === null ||
                    this.continueText === undefined
                ) {
                    this.continueText = message;
                }
            });
    }

    onCodeCompleted(code: string): void {
        this._code = Number(code);
    }

    submitSecurityCode() {
        if (this._code) this.codeProvided.next(this._code);
    }

    goBack(): void {
        this.back.next();
    }
}
